import React from "react";

import { selectTotalResouceAllocationEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import ViewPortOnly from "src/organization/pages/project/environment/metrics/components/ViewPortOnly";
import { getDistanceToPreload } from "src/organization/pages/project/environment/metrics/utils/helper";
import { useAppSelector } from "Store/hooks";

import UsageView from "./UsageView2";

const Page = () => {
  const enabled = useAppSelector(selectTotalResouceAllocationEnabled);
  const { rootMargin } = getDistanceToPreload();

  return enabled ? (
    <ViewPortOnly option={{ rootMargin }}>
      <UsageView />
    </ViewPortOnly>
  ) : null;
};
export default Page;
